<template>
    <div id="spinner" class="signalOverlay">
        <div class="signal"></div>
    </div>
</template>

<script>
    export default {
        name: "LoadingOverlay"
    }
</script>

<style scoped>
    .signalOverlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: whitesmoke;
        opacity: 0.9;
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=90)";
        filter: alpha(opacity=90);
        bottom: 10px;
        z-index: 100;
    }

    .signalOverlay .signal {
        border: 5px solid #333;
        border-radius: 30px;
        -ms-border-radius: 30px;
        -webkit-border-radius: 30px;
        -moz-border-radius: 30px;
        height: 30px;
        left: 50%;
        margin: -15px 0 0 -15px;
        opacity: 0;
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
        filter: alpha(opacity=0);
        position: absolute;
        top: 50%;
        width: 30px;
        animation: pulsate 1s ease-out;
        animation-iteration-count: infinite;
    }

    @keyframes pulsate {
        0% {
            transform: scale(0.1);
            -ms-transform: scale(0.1);
            -webkit-transform: scale(0.1);
            -moz-transform: scale(0.1);
            opacity: 0.0;
            -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
            filter: alpha(opacity=0);
        }
        50% {
            opacity: 1;
            -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
            filter: alpha(opacity=100);
        }
        100% {
            transform: scale(1.2);
            -ms-transform: scale(1.2);
            -webkit-transform: scale(1.2);
            -moz-transform: scale(1.2);
            opacity: 0;
            -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
            filter: alpha(opacity=0);
        }
    }
</style>